import { useState } from "react";
import { Send, Instagram, MessageCircle, Mail, Heart } from "lucide-react";
import { toast } from "sonner";
import { ASSETS } from "../lib/assets";
import {
  whatsappLink,
  instagramProfile,
  gmailLink,
  CONTACT,
} from "../lib/contact";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email.");
      return;
    }
    toast.success("Thanks! You're on the list.");
    setEmail("");
  };

  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="footer"
      className="border-t border-white/5 bg-black"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* brand */}
        <div className="lg:col-span-1">
          <img
            src={ASSETS.logo}
            alt="Velora"
            className="h-16 sm:h-20 w-auto object-contain -ml-3"
          />
          <p className="text-white/55 text-sm mt-5 leading-relaxed">
            We design and build websites that help brands grow and succeed
            online.
          </p>
          <div className="flex gap-3 mt-6">
            <a
              data-testid="footer-instagram"
              href={instagramProfile()}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white/10 hover:border-[rgb(182,245,0)] hover:bg-[rgba(182,245,0,0.08)] flex items-center justify-center transition-all"
            >
              <Instagram className="w-4 h-4 text-white" />
            </a>
            <a
              data-testid="footer-whatsapp"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white/10 hover:border-[rgb(182,245,0)] hover:bg-[rgba(182,245,0,0.08)] flex items-center justify-center transition-all"
            >
              <MessageCircle className="w-4 h-4 text-white" />
            </a>
            <a
              data-testid="footer-email"
              href={gmailLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white/10 hover:border-[rgb(182,245,0)] hover:bg-[rgba(182,245,0,0.08)] flex items-center justify-center transition-all"
            >
              <Mail className="w-4 h-4 text-white" />
            </a>
          </div>
        </div>

        {/* links */}
        <div>
          <h4 className="font-display text-white font-semibold mb-5">
            Quick Links
          </h4>
          <ul className="space-y-3 text-sm">
            {["home", "services", "founder", "process", "contact"].map((l) => (
              <li key={l}>
                <button
                  data-testid={`footer-link-${l}`}
                  onClick={() => go(l)}
                  className="text-white/55 hover:text-[rgb(182,245,0)] transition-colors capitalize"
                >
                  {l}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-white font-semibold mb-5">
            Services
          </h4>
          <ul className="space-y-3 text-sm text-white/55">
            <li>Web Design</li>
            <li>Web Development</li>
            <li>SEO & Performance</li>
            <li>Maintenance & Support</li>
          </ul>
        </div>

        {/* newsletter */}
        <div>
          <h4 className="font-display text-white font-semibold mb-5">
            Newsletter
          </h4>
          <p className="text-white/55 text-sm mb-4">
            Get the latest updates and insights delivered to your inbox.
          </p>
          <form
            data-testid="footer-newsletter"
            onSubmit={subscribe}
            className="relative"
          >
            <input
              data-testid="footer-newsletter-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full bg-black border border-white/10 focus:border-[rgb(182,245,0)] outline-none rounded-full pl-5 pr-14 py-3 text-sm text-white placeholder-white/30 transition-colors"
            />
            <button
              data-testid="footer-newsletter-submit"
              type="submit"
              className="absolute right-1.5 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[rgb(182,245,0)] hover:scale-105 transition-transform flex items-center justify-center"
              aria-label="Subscribe"
            >
              <Send className="w-4 h-4 text-black" />
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
          <div>© {new Date().getFullYear()} veloraweb.in. All rights reserved.</div>
          <div className="flex items-center gap-1.5">
            Made with{" "}
            <Heart className="w-3.5 h-3.5 fill-[rgb(182,245,0)] text-[rgb(182,245,0)]" />{" "}
            by Stavan Bhore · {CONTACT.email}
          </div>
        </div>
      </div>
    </footer>
  );
};
